var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-modal",style:(_vm.windowCls)},[_c(_vm.spec.view,{tag:"component",attrs:{"args":_vm.args},on:{"onResult":_vm.onResult}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }